import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class ConcessaoService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getConcessionTypes(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + `/v1/type-concessions`);
  }
}
